module.exports = __webpack_public_path__ + "img/pdf.b42accf7.svg";